'use client';

import { ArrowBackRounded } from '@mui/icons-material';
import { Button } from '@mui/material';

import { Link } from '@/configurations/i18n/navigation';

export function BackToCatalogueLink({
    dmcSlug,
    label,
    'data-testid': dataTestId,
}: {
    dmcSlug: string;
    label: string;
    'data-testid'?: string;
}) {
    return (
        <Button
            component={Link}
            href={`/dmcs/${dmcSlug}`}
            variant="outlined"
            size="small"
            startIcon={<ArrowBackRounded />}
            data-testid={dataTestId}
        >
            {label}
        </Button>
    );
}
